export default function AdminPagesAuditSummary({
  categoryOrder,
  categoryLabels,
  categoryCounts,
  statusOptions,
  statusCounts
}) {
  return (
    <div className="p-4 bg-muted rounded-lg" data-testid="pages-audit-summary">
      <h3 className="font-semibold mb-2">Résumé</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
        {categoryOrder.map((category) => (
          <div key={category} className="text-center p-2 bg-background rounded" data-testid={`pages-summary-${category}`}>
            <div className="text-2xl font-bold">{categoryCounts[category] || 0}</div>
            <div className="text-muted-foreground">{categoryLabels[category]}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm mt-4">
        {statusOptions.map((option) => (
          <div key={option.value} className="text-center p-2 bg-background rounded" data-testid={`pages-status-summary-${option.value}`}>
            <div className="text-2xl font-bold">{statusCounts[option.value] || 0}</div>
            <div className="text-muted-foreground">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}